import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deletePluviometroDigital } from '../service';
import {
  DELETE_PLUVIOMETRO_DIGITAL,
  DELETE_PLUVIOMETRO_DIGITAL_PENDING,
  DELETE_PLUVIOMETRO_DIGITAL_SUCCESS,
  DELETE_PLUVIOMETRO_DIGITAL_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeletePluviometroDigital(action) {
  yield put({ type: DELETE_PLUVIOMETRO_DIGITAL_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.PLUVIOMETRO_EXCLUIR);

  try {
    const a = yield call(deletePluviometroDigital, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PLUVIOMETRO_DIGITAL_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PLUVIOMETRO_DIGITAL_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeletePluviometroDigital() {
  yield takeLatest(DELETE_PLUVIOMETRO_DIGITAL, sagaDeletePluviometroDigital)
}
